<template>
  <v-container>
    <h1>Nie znaleziono strony</h1>
    <a href="#" @click.prevent="back">Cofnij</a>
  </v-container>
</template>

<script>
export default {
  methods: {
    back() {
      //window.location.href = "/404.html";
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>